import React from 'react'

const PublicRoutes = [
    {
        path: '/public',
        component: () => <div>Public Page</div>,
    },
]

export default PublicRoutes
